module.exports = __webpack_public_path__ + "img/ef-logo-tablet.a23b03e2.svg";